// From the pure schema entry of platform: this file is bundled into the web app through ./schema.
import { definePermissions } from '@mkcore/platform/schema';

/** Permissions of projects, subprojects and work types (D05). Object scope: grants per organisation, engagement or project. */
export const projectPermissions = definePermissions('projects', {
  read: 'View projects, subprojects and work types',
  create: 'Add projects, subprojects and work types',
  update: 'Change projects and work types; archive and restore; favourites',
  delete: 'Delete a project without time entries',
  export: 'Export projects',
  approve: 'Record the client consent: accept a milestone, decide on a change request (never an agent)',
});
